export default __webpack_public_path__ + "static/media/logoANCP.97ca23de.svg";